import CompanyModel from '@mm/state/model/CompanyModel';
import { SubscriptionModel } from '@mm/state/model/SubscriptionModel';
import * as Yup from 'yup';
import { getPlanPrice } from '@mm/state/helpers/get-plan-price';
import { SessionObject } from '@mm/state/interfaces/session';

export type CheckoutFormValues = {
  email: string;
  firstName: string;
  lastName: string;
  country: string;
  terms: boolean;
  company?: number;
};

const getInitialValues = (
  isTeam: boolean,
  company: CompanyModel,
  session: SessionObject,
) => {
  const initialValues: { [key: string]: any } = {
    email: session.email || '',
    firstName: session.firstName || '',
    lastName: session.lastName || '',
    country: 'US',
    terms: false,
  };

  if (isTeam) {
    initialValues.company = company.id;
  }

  return initialValues;
};

const fields = {
  email: 'email',
  firstName: 'firstName',
  lastName: 'lastName',
  country: 'country',
  terms: 'terms',
  company: 'company',
};

const getValidationSchema = (isTeam: boolean) => {
  const fields: { [key: string]: any } = {
    email: Yup.string()
      .email('Email field must be a valid email')
      .trim()
      .required('Email Required'),
    firstName: Yup.string().trim().required('First Name Required'),
    lastName: Yup.string().trim().required('Last Name Required'),
    country: Yup.string().required('Country Required'),
    terms: Yup.boolean().oneOf([true], 'Must Accept Terms and Conditions'),
  };

  if (isTeam) {
    fields.company = Yup.string().required('Company Required');
  }

  return Yup.object().shape(fields);
};

export const getProRatedAmount = (subscription?: SubscriptionModel) => {
  const priceFactor = subscription ? subscription.priceFactor : undefined;
  const coupon = subscription ? subscription.coupon : undefined;
  const price = subscription ? subscription.basePrice : undefined;

  if (priceFactor && price) {
    return priceFactor * getPlanPrice(price, coupon);
  }
};

const CheckoutFormHelpers = {
  getInitialValues,
  fields,
  getValidationSchema,
};

export default CheckoutFormHelpers;
